/**
 * chatImportHandoff — puente chat → importador de animales.
 *
 * El usuario arrastra/adjunta una planilla (.xlsx/.csv) en el CHAT: el archivo
 * no pasa por el modelo (no puede leer adjuntos). En su lugar se guarda acá y
 * se navega a /animals?open_import=1; AnimalesPage abre el ImportAnimalsModal
 * y le pasa el archivo para que el importador inteligente arranque solo
 * (detecta columnas, preview editable, chequeo de duplicados).
 *
 * Lleva también el sessionId del chat de origen: cuando la importación
 * TERMINA, AnimalesPage avisa al backend (POST /api/chat/import/notify) para
 * que el AGENTE sepa que esos animales ya están cargados (mismo mecanismo que
 * el confirm por botón — el import no pasa por el loop del LLM).
 *
 * Es un singleton en memoria de la sesión (no persiste: si el usuario
 * recarga, el modal abre vacío — flujo normal de upload).
 */

const SPREADSHEET_EXTENSIONS = ['.xlsx', '.xls', '.csv'];

interface ChatImportHandoff {
  file: File;
  sessionId?: string;
}

let handoff: ChatImportHandoff | null = null;

export function isSpreadsheetFile(file: File): boolean {
  const name = file.name.toLowerCase();
  return SPREADSHEET_EXTENSIONS.some((ext) => name.endsWith(ext));
}

/** Guarda el archivo que el usuario tiró al chat (con su sesión de origen). */
export function setHandoffFile(file: File, sessionId?: string): void {
  handoff = { file, sessionId: sessionId || undefined };
}

/** Lo consume AnimalesPage al abrir el importador (una sola vez). */
export function consumeHandoffFile(): ChatImportHandoff | null {
  const h = handoff;
  handoff = null;
  return h;
}
